import { useRef, useEffect, useCallback, PropsWithChildren, FC, useState } from 'react'
import { Spin, Select } from 'antd'
import DualAxes from '@/pages/Bmjy/components/components/DualAxes'
import CardContainer from '@/pages/Bmjy/components/components/CardContainer'

const tabsOptions = [
  {
    label: '按院', 
    value: 'ay',
    api: null
  }, 
  {
    label: '按所', 
    value: 'as',
    api: null
  }
]

const filterOptions = [
  {
    label: '支出', 
    value: 'zc',
  }, 
  {
    label: '成本', 
    value: 'cb',
  }, 
]

type PropType = FC<PropsWithChildren<{
  updateTime: string
}>>

const Component: PropType = ({updateTime}) => {
  const [loading, setLoading] = useState(false)
  const [bnData, setBnData] = useState([])
  const [snData, setSnData] = useState([])
  const [zbData, setZbData] = useState([])
  const [filterType, setFilterType] = useState('zc')
  const globalRef = useRef({
    params: {
      tab: '',
      depart: ''
    },
    loadTime: updateTime
  })

  const mockData = useCallback(() => {
    const data1 = []
    const data2 = []
    const data3 = []
    for(let i=0; i<12; i++) {
      data1.push({
        "label": i+ 1 + "所",
        "value": Math.floor(Math.random()*100)
      })
      data2.push({
        "label": i+ 1 + "所",
        "value": Math.floor(Math.random()*100)
      })
      data3.push({
        "label": i+ 1 + "所",
        value: Math.floor(Math.random()*100)
      })
    }
    setBnData(data1)
    setSnData(data2)
    setZbData(data3)
  }, [])
  
  // 获取图表数据
  const getColumnData = useCallback(async () => {
    const tabOption = tabsOptions.find(t => t.value === globalRef.current.params.tab)
    mockData()
    if(!tabOption || !tabOption.api) {
      return
    }
    console.log(filterType)

    const res = await tabOption.api()
    if(res.success) {
    }
  }, [filterType, mockData])

  // 获取统计数据
  const getTotal = useCallback(async () => {
    
  }, [])

  // 获取接口数据
  const getList = useCallback(async () => {
    setLoading(true)
    Promise.all([getColumnData(), getTotal()]).finally(() => {
      setLoading(false)
    })
  }, [filterType, getColumnData, getTotal])

  // 变更类型
  const handleTabChange = useCallback((value) => {
    globalRef.current.params = value
    getList()
  }, [getList])

  useEffect(() => {
    if(globalRef.current.loadTime !== updateTime) {
      globalRef.current.loadTime = updateTime
      getList()
    }
  }, [updateTime, getList])

  return (
    <Spin spinning={loading} wrapperClassName='full-spin'>
      <CardContainer
        tabs={tabsOptions}
        onTabChange={handleTabChange}
        title='各部门年度统计'
        customFilter={
          <div className='ml-10'>
            <Select value={filterType} onChange={setFilterType} size='small'>
              {
                filterOptions.map(r => <Select.Option value={r.value} key={r.value}>{r.label}</Select.Option>)
              }
            </Select>
          </div>
        }
      >
        <div className='h-full pt-20'>
          {
            filterType === 'zc' && (
              <DualAxes
                bar1Label="本年支出(万)"
                bar1Data={bnData}
                bar2Label='上年支出(万)'
                bar2Data={snData}
                lineLabel='本年占比去年支出总数(%)'
                lineData={zbData}
              />
            )
          }
          {
            filterType === 'cb' && (
              <DualAxes
                bar1Label="本年成本(万)"
                bar1Data={bnData}
                bar2Label='上年成本(万)'
                bar2Data={snData}
                lineLabel='本年占比去年成本总数(%)'
                lineData={zbData}
              />
            )
          }
        </div>
      </CardContainer>
    </Spin>
  )
}

export default Component
